/**
 *
 * 渲染 单独一张优惠券 使用ANTD 提示
 * 功能 ：判断状态 显示可否领用及领用回调动作
 * Author:   fjj
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/09/29    1.0     First version
 *
 * Copyright  2021 , all rights reserved. Essa.cn
 *
 * 参数：如下
 * couponItem: 券的数据 - 必传
 * handleSuccessAction : 成功领用需要回调的动作
 * handleFailAction : 失败领用需要回调的动作
 * flagUserOtherStyle: 默认当前样式，如果有传，将采用填写的样式标题
 * flagShowBtn ： 是否显示 领用|已领用 按钮，默认显示
 *
 * 方式2 直接传入渲染样式 只保存动作
 * flagRenderComponent
 * */
import React,{Fragment} from "react";
import {message,Spin } from "antd";
import CommonCoupon from "../common-coupon";
import {getTime, getTip, goodsRangeType} from "../common";

class OneCoupon extends React.Component {
    static defaultProps = {
        couponItem:{},
        UserOtherStyle:'coupon-item',
        flagShowBtn:true,
        flagRenderComponent:false,
    };
    constructor(props) {
        super(props);
        this.state={
            loading: false
        }
        this.window = props.serverWindow ? props.serverWindow : window;
        this.$i18n = this.window.__getServerLanguage;
    }
    // onClickReceiving(item){
    //     const flagLogin = window.__USER.isLogin;
    //     // 调用接口前判断是否登录，未登录先跳转登录，传参 saleCouponActivityId 活动ID saleCouponId优惠券ID
    //     if (!flagLogin) {
    //         message.warning(this.$i18n('QingXianDengLuNMiaoHouJiangTiaoZhuan'));
    //         setTimeout(function () {
    //             window.location.href = "/login?url=" + __URL_ENCODE;
    //         }, 1000);
    //         return false;
    //     }else {
    //         this.loading(true);
    //         const sUrl ='/data/mc/r/coupon/receive-coupon';
    //         const data = {
    //             saleCouponId: item.saleCouponId,
    //             saleCouponActivityId:item.saleCouponActivityId
    //         };
    //         this.postHttpAction(sUrl,data,resData=>{
    //             // 响应结果
    //             this.timer = setTimeout(()=>{
    //                 this.loading(false);
    //             },400);
    //             let { success, valid,resultCode } = resData;
    //             if (success && valid) {
    //                 // 成功 响应结果
    //                 message.success(this.$i18n('LingYongChengGong'));
    //                 if(this.props.handleSuccessAction)this.props.handleSuccessAction(item);
    //             }else if(resultCode=='message01E'){ //重复领用只提示
    //                 message.warning(this.$i18n('YiLingQuChengGongQingWuChongFuLingQu'));
    //             }else {
    //                 if(!resData.message&&!resData.failMessage)message.warning(this.$i18n('LingYongShiBai'));
    //                 if(this.props.handleFailAction)this.props.handleFailAction(resData);
    //             }
    //         });
    //
    //     }
    //
    // }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    postHttpAction(sUrl,data, callback){
        return $.ajax({
            url: sUrl,
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify(data),
            success:(res)=>{
                callback(res);
            }
        });
    }
    componentWillUnmount() {
        clearTimeout(this.timer);
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { loading } = this.state;
        const {serverWindow,couponItem,UserOtherStyle,flagShowBtn,flagRenderComponent,renderComponent} = this.props;
        const sStatus = couponItem.status;
        return (<div className={UserOtherStyle}>
            <Spin spinning={loading}>
                {/* 没有点击事件 onClick={()=>this.onClickReceiving(couponItem)} */}
                {flagRenderComponent?<div>
                    {this.props.children}
                </div>:<Fragment>
                    <h2><CommonCoupon item={couponItem} serverWindow={serverWindow} /></h2>
                    <small>{getTip(couponItem,serverWindow)}</small>
                    {/*{flagShowBtn&&(sStatus=='enable'?<div className={"cou-isreceived-no"}*/}
                                                          {/*onClick={()=>this.onClickReceiving(couponItem)}>{this.$i18n('LingYong')}</div>:(sStatus=='expire'?<div className={"cou-isreceived"}>{this.$i18n('YiLingWan')}</div>:<div className={"cou-isreceived"}>{this.$i18n('YiLingYong')}</div>))}*/}
                    <div className="product-range">{goodsRangeType(couponItem,serverWindow)}</div>
                    <div className="validity-range">{getTime(couponItem,serverWindow,flagShowBtn)}</div>
                </Fragment>}
            </Spin>
                </div>)
    }
}

export default OneCoupon;